import React, { Dispatch, SetStateAction } from 'react';
import styles from './headerMenuDrawer.module.scss';
import { useNoAuthHooks } from '../../../../../../../../Hooks/hooks';
import useHeaderMenuDrawer from './headerMenuDrawer-hook';
import Languages from '../../../../../../../../Components/Languages/languages';
import ModeSwitcher from '../../../../../../../../Components/ModeSwitcher/modeSwitcher';
import { VisitorPageContents } from '../../../../../visitorPage';
import { ReserveIcon } from '../../../../../../../../Components/IconComponents';
import useLanguagesHooks from '../../../../../../../../Components/Languages/setLanguage-hooks';

export interface IHeaderMenuDrawerProps {
    logo: string,
    onClose: () => void,
    active: VisitorPageContents,
    companyId: number,
    setContentType: Dispatch<SetStateAction<VisitorPageContents>>,
    is_user: boolean,
    tableReservation: boolean | undefined;
    onReserveTableDialog: () => void
}

const HeaderMenuDrawer: React.FC<IHeaderMenuDrawerProps> = (props) => {
    const { logo, active, tableReservation, onReserveTableDialog } = props;
    const { baseURL } = useNoAuthHooks();
    const { t } = useLanguagesHooks();
    const { headerMenuDrawerItems } = useHeaderMenuDrawer(props)

    return (
        <div className={styles.container}>
            <div className={styles.logoBox}>
                <img src={`${baseURL}${logo}`} alt='logo.png' className={styles.logo} />
            </div>
            <div className={styles.itemBox}>
                {
                    headerMenuDrawerItems.map((nav) => {
                        const isActive = nav.id === active;
                        return (
                            <div
                                key={nav.id}
                                className={isActive ? styles.activeNavItem : styles.navItem}
                                onClick={isActive ? undefined : nav.onClick}>
                                <p>{nav.title}</p>
                            </div>
                        )
                    })
                }
            </div>
            {
                tableReservation &&
                <div className={styles.reserveBox}>
                    <div className={styles.reserveButton} onClick={onReserveTableDialog}>
                        <ReserveIcon color='white' />
                        <p>{t('Visitor.Reserve_Button')}</p>
                    </div>
                </div>
            }
            <div className={styles.settingBox}>
                <Languages />
                <ModeSwitcher />
            </div>
        </div>
    )
};

export default HeaderMenuDrawer
